import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import * as React from 'react';
import { CardContext, forceMobile, numberFormatter } from '../generics';
import { jsx as _jsx } from "theme-ui/jsx-runtime";
import { jsxs as _jsxs } from "theme-ui/jsx-runtime";

// This isn't complete yet
var ProductTableDataValue = function ProductTableDataValue(_ref) {
  var value = _ref.value,
      unit = _ref.unit,
      subscript = _ref.subscript;

  var _React$useContext = React.useContext(CardContext),
      isCard = _React$useContext.isCard;

  var forcedMobile = forceMobile(isCard);
  var boldNumber = isCard ? {
    fontWeight: '600',
    whiteSpace: 'nowrap'
  } : {};
  var removeBold = isCard ? {
    fontWeight: '400'
  } : {};
  return _jsxs("span", {
    sx: boldNumber,
    children: [numberFormatter(value, unit), typeof value === 'number' && subscript ? _jsx("span", {
      sx: _objectSpread({
        fontSize: function fontSize(theme) {
          var _theme$compounds$prod, _theme$compounds$prod2;

          return forcedMobile(((_theme$compounds$prod = theme.compounds['product-table'].cellContent) === null || _theme$compounds$prod === void 0 ? void 0 : (_theme$compounds$prod2 = _theme$compounds$prod.subscript) === null || _theme$compounds$prod2 === void 0 ? void 0 : _theme$compounds$prod2.fontSize) || ['xs', 'md']);
        }
      }, removeBold),
      children: "".concat(subscript)
    }) : null]
  });
};

var PlainProductTableDataValue = function PlainProductTableDataValue(props) {
  var value = props.value,
      unit = props.unit,
      subscript = props.subscript;
  return [numberFormatter(value, unit), typeof value === 'number' && subscript ? subscript : null].filter(function (i) {
    return !!i;
  }).join(' ');
};

export default ProductTableDataValue;
export var Rich = ProductTableDataValue;
export var Plain = PlainProductTableDataValue;
//# sourceMappingURL=data-value.js.map